import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import ImageGrid from './ImageGrid';

const AIAudioFileFormats = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Comprehensive Audio File Support for AI Audio Summarizer & Note Taker",
      description: "Comprehensive Audio File Support for AI Audio Summarizer Our AI audio summarizer and AI note taker support all major audio and video file formats, allowing you to upload recordings for instant AI summaries and audio transcription. The platform automatically detects file types and optimizes processing for each format, ensuring fast, accurate, and reliable results with our audio transcript generator. Perfect for meetings, lectures, podcasts, and YouTube videos, so you can convert any audio into actionable notes effortlessly.",
      sections: [
        {
          icon: "fas fa-file-audio",
          color: "#ffd700",
          title: "Multiple File Formats & TXT Support",
          description: "Upload your audio in various file formats including MP3, WAV, M4A, OGG, FLAC, and TXT files. Our platform handles all audio formats and provides length options to meet your needs."
        },
        {
          icon: "fas fa-video",
          color: "#ff6b6b",
          title: "Video File Processing",
          description: "Extract audio from video files including MP4, AVI, MOV, and convert them to text summaries. Perfect for YouTube videos, lectures, and recorded meetings."
        },
        {
          icon: "fas fa-language",
          color: "#4ecdc4",
          title: "Multilingual Support",
          description: "Process audio files in 95+ languages with high accuracy. Our AI understands context and nuances across different languages and dialects."
        },
        {
          icon: "fas fa-clock",
          color: "#45b7d1",
          title: "Instant Processing",
          description: "Get your audio summary in seconds, not minutes. Our optimized AI processes files quickly while maintaining high accuracy and detail."
        }
      ]
    },
    ar: {
      title: "دعم شامل لتنسيقات ملفات الصوت والفيديو الخاصة بك من خلال الذكاء الاصطناعي",
      description: "هو أداة ذكية تدعم جميع أنواع ملفات الصوت وملفات الفيديو الخاصة بك مع تحويل الصوت إلى نص في وقت قصير مما يسهل سير عملك",
      sections: [
        {
          icon: "fas fa-file-audio",
          color: "#ffd700",
          title: "تنسيقات متعددة من ملفات الصوت والفيديو الخاصة بك",
          description: "دعم شامل لجميع التنسيقات الشائعة والمتخصصة الخاصة بك مع تحويل الصوت إلى نص بسرعة بما في ذلك تلخيص مقاطع الفيديو"
        },
        {
          icon: "fas fa-video", 
          color: "#ff6b6b",
          title: "معالجة ملفات الفيديو",
          description: "استخراج الصوت من ملفات الفيديو بما في ذلك MP4 وAVI وMOV وتحويلها إلى ملخصات نصية. مثالي لفيديوهات يوتيوب والمحاضرات والاجتماعات المسجلة."
        },
        {
          icon: "fas fa-language",
          color: "#4ecdc4", 
          title: "دعم متعدد اللغات",
          description: "معالجة الملفات الصوتية بأكثر من 95 لغة بدقة عالية. ذكاءنا الاصطناعي يفهم السياق والفروق الدقيقة عبر اللغات واللهجات المختلفة."
        },
        {
          icon: "fas fa-clock",
          color: "#45b7d1",
          title: "معالجة فورية",
          description: "احصل على ملخص صوتي في ثوانٍ وليس دقائق. ذكاءنا الاصطناعي المحسن يعالج الملفات بسرعة مع الحفاظ على الدقة العالية والتفاصيل."
        }
      ]
    }
  };

  const currentContent = content[language];

  return (
    <div className="container-fluid mb-5" style={{ 
      backgroundColor: '#000000', 
      padding: '80px 0',
      fontFamily: '"Nunito Sans", "Montserrat", "Trebuchet MS", sans-serif'
    }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            <div className="text-center mb-5">
              <h2 className="fw-bold mb-3" style={{ 
                fontSize: '2.25rem', 
                fontWeight: '700', 
                color: '#ffffff',
                fontFamily: '"Roboto", "Poppins", sans-serif'
              }} data-aos="fade-up">
                {currentContent.title}
              </h2>
              <p className="lead" style={{ 
                fontSize: '1.1rem', 
                lineHeight: '1.7', 
                color: 'rgba(255, 255, 255, 0.85)',
                fontFamily: '"Tinos", "Times New Roman", serif'
              }} data-aos="fade-up" data-aos-delay="100">
                {currentContent.description}
              </p>
              <p className="mt-3" style={{ 
                color: 'rgba(255, 255, 255, 0.7)', 
                lineHeight: '1.6',
                fontFamily: '"Tinos", "Times New Roman", serif'
              }} data-aos="fade-up" data-aos-delay="200">
                
              </p>
            </div>

            <div className="row mb-5">
              {currentContent.sections.map((section, index) => {
                const gradients = [
                  'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                  'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                  'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'
                ];
                return (
                  <div key={index} className="col-lg-6 mb-4" data-aos="fade-up" data-aos-delay={300 + (index * 100)}>
                    <div 
                      className="card border-0 shadow-sm h-100"
                      style={{
                        background: gradients[index],
                        color: 'white',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-8px)';
                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                      }}
                    >
                      <div className="card-body p-4 text-center">
                        <i 
                          className={`${section.icon} fa-3x mb-3`}
                          style={{ color: 'rgba(255,255,255,0.9)' }}
                        ></i>
                        <h5 
                          className="mb-3"
                          style={{ 
                            color: 'white !important',
                            fontSize: '1.25rem',
                            fontWeight: '600',
                            fontFamily: '"Roboto", "Poppins", sans-serif'
                          }}
                        >
                          {section.title}
                        </h5>
                        <p style={{ 
                          color: 'rgba(255,255,255,0.9)',
                          fontSize: '0.95rem',
                          lineHeight: '1.6',
                          fontFamily: '"Tinos", "Times New Roman", serif'
                        }}>
                          {section.description}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Add ImageGrid here - using gridType 3 for file formats */}
            <div className="mt-5 pt-4" data-aos="fade-up" data-aos-delay="700">
              <ImageGrid gridType={2} className="text-dark" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIAudioFileFormats;